
import {Component, Prop, Vue} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import {answerStateText, QueryStage} from "@/components/query/QueryStates";
import IQueryOverviewShortDto = MdbsCore.IQueryOverviewShortDto;

@Component({
  name: 'QueryStateIcon',
  components: {},
})
export default class QueryStateIcon extends Vue {

  @Prop({required: true})
  private query!: IQueryOverviewShortDto;

  get stageStateIcon() {
    // TODO: add translations to def
      let icon = "fa-archive";
      let color = "success";
      let toolTip = "Geschlossen";

      const answerState = answerStateText(this.query.stageState, this.query.closedReason, this.query.lastComment);

      if (this.query.stageState == QueryStage.OPEN) {
        icon = "fa-file";
        toolTip = "Offen";

        if (this.query.lastComment?.creatingUserRoleIdentifier == "Physician" ||
            this.query.lastComment?.creatingUserRoleIdentifier == "Nurse")
          color = "info";
        else
          color = "error"
      }
      if (this.query.stageState == QueryStage.PENDING) {
        icon = "fa-file-alt";
        color = "secondary";
        toolTip = "Ausstehend";
      }

    if (this.query.stageState == QueryStage.NO_LONGER_RELEVANT) {
      icon = "fa-file-alt";
      color = "grey";
      toolTip = "Nicht mehr relevant";
    }

    if (this.query.stageState == QueryStage.INVISIBLE) {
      icon = "fa-file-alt";
      color = "grey";
      toolTip = "Unsichtbar";
    }

      toolTip = toolTip + answerState;
      return {icon, color, toolTip}
  }



}
